import React, { FC } from 'react';
import { SearchAdvice } from './SearchAdvice';
import { Connect, PropsFromRedux } from './SearchAdviceWizardContainer';

type Props = PropsFromRedux;

export const RawSearchAdviceWizard: FC<Props> = ({ adviceAction }) => {
  if (!adviceAction) return null;
  return <SearchAdvice advice={adviceAction} />;
};

export const SearchAdviceWizard = Connect(RawSearchAdviceWizard);
